import { Button, Card } from "antd"
import { usePathname, useRouter } from "next/navigation"
import { t } from "../../languages/i18n"

export const BlockContentNavigator = ({ edit, blockContentId }: { edit: boolean; blockContentId?: number | null }) => {
  const router = useRouter()
  const pathname = usePathname()

  const isTranslatePage = pathname?.includes("/translate")
  const canEditUIBuilder = edit && !isTranslatePage

  return (
    <div>
      <Card className=" min-h-60 items-center justify-center flex">
        {canEditUIBuilder ? (
          <Button
            type="primary"
            size="large"
            className="font-semibold text-3xl h-20 px-10"
            onClick={() => router.push(`/admin/ui-builder?id=${blockContentId}`)}
          >
            {t("Edit with UI Builder")}
          </Button>
        ) : (
          <div className="font-semibold text-xl text-orange-500">{t("Press save button to access UI Builder")}</div>
        )}
      </Card>
    </div>
  )
}
